import { useEffect, useState } from 'react';
import { useNavigate, redirect, useParams } from 'react-router-dom';

import config from '../config';
import InputWithError from '../catalyst/custom/inputWithError';

import Spinning from '../components/spinning';
import { ErrorMessage, Field } from '../catalyst/fieldset';
import { Logo } from '../logo';
import { AuthLayout } from '../catalyst/auth-layout';
import { Button } from '../catalyst/button';
import { TextLink } from '../catalyst/text';
import { Text } from '../catalyst/text';
import {
    Strong

} from '../catalyst/text';
import { Heading } from '../catalyst/heading';
import { Link } from '../catalyst/link';
// TODO remove, this demo shouldn't need to reset the theme.

export default function ResetPassword() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [errResponse, setErrResponse] = useState("");
    const [submitting, setSubmitting] = useState(false)

    const { token, userId } = useParams();

    const [formData, setFormData] = useState({
        passwordResetToken: token,
        id: userId,
        password: '',
        confirmPassword: ''
    });


    const validate = (submittedFormData) => {
        let errors = {};

        if (!submittedFormData.password) {
            errors.password = "Password is required";
        } else if (submittedFormData.password.length < 6) {
            errors.password = "Password must be at least 6 characters";
        }

        if (!submittedFormData.confirmPassword) {
            errors.confirmPassword = "Confirm password is required";
        } else if (submittedFormData.confirmPassword !== submittedFormData.password) {
            errors.confirmPassword = "Passwords do not match";
        }

        return errors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        var formDataObj = new FormData(e.currentTarget);
        var newData = {
            passwordResetToken: token,
            id: userId,
            password: formDataObj.get('password'),
            confirmPassword: formDataObj.get('confirmPassword')
        }
        setFormData(newData)

        const validationErrors = validate(newData);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            setSubmitting(true)
            fetch(config.apiUrl + "/user/updatePassword", { // Replace with your actual endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            })
                .then(response => {
                    setSubmitting(false)
                    if (!response.ok) {
                        if (response.status === 400) {
                            return response.text().then(text => {
                                throw new Error(text || 'Something went wrong');
                            });
                        }
                        throw new Error('Sorry, some error occured. Please try again later or let us know');
                    }
                    return response.text();
                })
                .then(data => {
                    setErrResponse("Your password is updatted, please login to continue.");
                    setSubmitting(false)
                    navigate(config.loginPath + "?message=PASSWORD_UPDATED")
                })
                .catch((error) => {
                    setSubmitting(false)
                    setErrResponse(error.message)
                    console.error('Error:', error);
                });
        }
    };

    return (

        <AuthLayout>
            <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8">
                <div className="flex flex-col items-center justify-center space-y-4">
                    <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" />
                    <Heading>Update your password</Heading>

                    </div>
                   
                    <InputWithError error={errors.password} type="password" name="password" label={"Password"} onChange={() => { }} />
                    <InputWithError error={errors.confirmPassword} type="password" name="confirmPassword" label={"Confirm Password"} onChange={() => { }} />



                    {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}

                    <div className="flex items-center justify-between">

                    <Button type="submit" className="w-full cursor-pointer" disabled={submitting}>
                        {submitting ? <Spinning /> : "Update Password"}
                    </Button>
                    </div>


                    <div className="flex items-center justify-between">

                            <Link href={config.loginPath}>
                                <Strong>Back to Login</Strong>
                            </Link>
                    </div>

            </form>
        </AuthLayout>




    );
}